import React from 'react';
import CauseHeader from './CauseHeader';
import CauseWorkspace from './CauseWorkspace';

/**
 * Renderiza el bloque CauseAnalysisView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function CauseAnalysisView({
  v
}) {
  return v.viewCz ? React.createElement(React.Fragment, null, v.text("\n  "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateRows": "auto minmax(0,1fr) auto",
      "gap": "1.111111vh"
    }
  }, v.text("\n    "), React.createElement(CauseHeader, {
    v
  }), v.text("\n    "), React.createElement(CauseWorkspace, {
    v
  }), v.text("\n    "), React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.111111vh 1.296296vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "0.925926vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.296296vh",
      "fontWeight": "600"
    }
  }, v.text("Reglas encontradas"))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "repeat(4,minmax(0,1fr))",
      "gap": "0.925926vh",
      "alignItems": "start"
    }
  }, (v.czRules || []).map((u, index96) => React.createElement(React.Fragment, {
    key: index96
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "padding": "0.925926vh 1.111111vh",
      "borderRadius": "0.740741vh",
      "background": "rgba(3,10,22,0.45)",
      "border": "0.092593vh solid " + u.bd,
      "minWidth": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "0.740741vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 1.851852vh 'IBM Plex Mono',monospace",
      "color": u.c
    }
  }, v.text(u.lift)), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, v.text("PPA"))), v.text("\n        "), React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "color": "#e4e9f0",
      "lineHeight": "1.35",
      "textWrap": "pretty"
    }
  }, v.text(u.txt)), v.text("\n        "), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#8793a6"
    }
  }, v.text(u.time + " · " + u.loss)), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.555556vh",
      "flexWrap": "wrap"
    }
  }, React.createElement("button", {
    "onClick": u.mark,
    style: {
      "border": "0.092593vh solid oklch(0.66 0.19 42 / 0.7)",
      "background": u.markBg,
      "color": u.markC,
      "borderRadius": "0.462963vh",
      "padding": "0.277778vh 0.740741vh",
      "cursor": "pointer",
      "font": "1.018519vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap"
    }
  }, v.text(u.markL)), React.createElement("button", {
    "onClick": u.toggle,
    style: {
      "border": "0.092593vh solid rgba(46,179,238,0.25)",
      "background": "transparent",
      "color": "#b8c1ce",
      "borderRadius": "0.462963vh",
      "padding": "0.277778vh 0.740741vh",
      "cursor": "pointer",
      "font": "1.018519vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap"
    }
  }, v.text(u.casesL))), v.text("\n        "), u.casesOn ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh",
      "paddingTop": "0.37037vh",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.1)"
    }
  }, (u.cases || []).map((k, index97) => React.createElement(React.Fragment, {
    key: index97
  }, React.createElement("div", {
    "onClick": k.go,
    "title": "Abrir en Detalle diario con la regla marcada",
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.740741vh",
      "padding": "0.277778vh 0.37037vh",
      "borderRadius": "0.37037vh",
      "cursor": "pointer",
      "font": "1.018519vh 'IBM Plex Mono',monospace"
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {
    style: {
      "color": "#e4e9f0",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.t)), React.createElement("span", {
    style: {
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.v + " ›"))))))) : null, v.text("\n      "))))), v.text("\n    ")), v.text("\n  ")), v.text("\n  ")) : null;
}
